import { Component, OnInit, Input } from '@angular/core';

  @Component({
    selector: 'company-list-ttt',
    templateUrl: './a-company-list.component.html',
})
export class ACompanyListComponent{
    @Input() companylist: any;

    public selected_id:number=null;

    constructor(
    ) { }

    ngOnInit() {
        if(this.companylist.length == 1){
            this.selected_id = this.companylist[0].id;
        }else{
            this.selected_id = null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/a0106-mail/a-company-list.component.ts